import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import HtmlEditorField from '../../../HtmlEditorField';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class AnnouncementForm extends Component {
    static displayName = AnnouncementForm.name;

    constructor(props) {
        super(props);
        this.state = {
            announcement: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newAnnouncement = this.state.announcement;
        newAnnouncement[e.target.name] = e.target.value;
        this.setState({ announcement: newAnnouncement });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let announcement = this.state.announcement;
        announcement.versionId = this.state.versionId;
        announcement.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateAnnouncement" : "CreateAnnouncement";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(announcement),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                    var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "Announcement", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    
                    //window.location = '/UpdatePageComponent/' + this.state.pageId;
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        let announcementText = null;
        let componentName = null;

        if (this.state.announcement != null) {
            let announcement = this.state.announcement;
            announcementText = announcement.announcementText;
            componentName = announcement.componentName;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        let editorWrapper = this.state.versionStatus == 'draft' ? 'editor-wrapper' : 'editor-wrapper disable-wrapper';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid' id='announcementSection'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('Announcement')}</h2>
                    </div>

                    <label htmlFor='announcement-componentName'>Component Name:</label>
                    <input id='announcement-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                 
                    <label>Announcement Text: </label>
                    {/*<input name='announcementText' type='text' defaultValue={announcementText} onChange={this.handleChange} required />*/}
                    <div className={editorWrapper}>
                        <HtmlEditorField content={announcementText} handleEditorChange={this.handleChange} name='announcementText' returnAsEvent={true} />
                    </div>

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetAnnouncement?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            announcement: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteAnnouncement?componentId=' + this.state.announcement.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                //window.location = '/UpdatePageComponent/' + this.state.pageId;
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default AnnouncementForm;
